import { z } from 'zod/v4';

import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

export const companyOrderStatusOptions = [
  'Complete',
  'Pending',
  'Failed',
] as const;

export const companyOrderStatusSchema = createEnumSchemaPreprocessor(
  z.enum(companyOrderStatusOptions),
  companyOrderStatusOptions
);

export type CompanyOrderStatus = z.infer<typeof companyOrderStatusSchema>;
